import { render } from "./FloristMeetingProductProposal.vue?vue&type=template&id=f4438ff4"
import script from "./FloristMeetingProductProposal.vue?vue&type=script&lang=js"
export * from "./FloristMeetingProductProposal.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__